import Loader from "../components/Loader";
import Marquee, { MarqueeDirections } from "../components/Marquee";
import Paginator from "../components/Paginator";

export default class PageNewsList {
  constructor({ template, postsPerPage, data, loader }) {
    this.data = data;
    this.paginator = new Paginator(null, null, null, false, postsPerPage);
    this.template = template;
    this.loader = loader;
  }

  init(data) {
    this.paginator.dataFromServer = this.data;
    this.paginator.template = this.template;
    this.paginator.wrapperClass = ".grid-container-news";
    this.paginator.init();
    if (this.loader) {
      this.loader.toggle(false);
    }

    const firstMarquee = new Marquee({
      cssClass: ".js-swiper-text",
      direction: MarqueeDirections.leftToRight,
      slidesPerView: 3,
    });

    firstMarquee.init();
  }
}
